/**
 * Creates dynamic dispatchers to fire reducers on action completion
 * @param name
 * @param action
 * @returns {*|{type: *}}
 */
const createDynamicAction = (name, action) => {
    const placeholder = {
        [name](args) {
            return {type: action, ...args};
        }
    };
    return placeholder[name];
};

export default createDynamicAction;